import { createRouter, createWebHistory } from 'vue-router'
import { useIdpAuth } from '../composables/useIdpAuth'
import { useUserStore } from '../stores/user'
import ApplicationList from '../views/ApplicationList.vue'
import ServiceList from '../views/ServiceList.vue'
import AgencyList from '../views/AgencyList.vue'
import PositionDecisionMakerList from '../views/PositionDecisionMakerList.vue'
import CounterpartyList from '../views/CounterpartyList.vue'
import PaymentAccountList from '../views/PaymentAccountList.vue'
import ContractList from '../views/ContractList.vue'
import InvoiceList from '../views/InvoiceList.vue'
import ReasonOfLeavingList from '../views/ReasonOfLeavingList.vue'
import PaymentPeriodsList from '../views/PaymentPeriodsList.vue'
import AdminProjectsList from '@/views/AdminProjectsList.vue'

const routes = [
  {
    path: '/',
    redirect: '/reference/applications'
  },
  {
    path: '/reference',
    name: 'Reference',
    redirect: '/reference/applications',
    children: [
      {
        path: 'applications',
        name: 'Applications',
        component: ApplicationList
      },
      {
        path: 'services',
        name: 'Services',
        component: ServiceList
      },
      {
        path: 'agencies',
        name: 'Agencies',
        component: AgencyList
      },
      {
        path: 'position-decision-makers',
        name: 'PositionDecisionMakers',
        component: PositionDecisionMakerList
      },
      {
        path: 'counterparties',
        name: 'Counterparties',
        component: CounterpartyList
      },
      {
        path: 'reasons-of-leaving',
        name: 'ReasonOfLeaving',
        component: ReasonOfLeavingList
      }
    ]
  },
  {
    path: '/admin',
    name: 'Admin',
    redirect: '/admin/all-projects',
    children: [
      {
        path: 'all-projects',
        name: 'AllProjects',
        component: AdminProjectsList
      }
    ]
  },
  {
    path: '/payment-accounts',
    name: 'PaymentAccounts',
    component: PaymentAccountList
  },
  {
    path: '/payment-accounts/:id',
    name: 'PaymentAccountDetail',
    component: () => import('../views/PaymentAccountDetail.vue')
  },
  {
    path: '/contracts',
    name: 'Contracts',
    component: ContractList
  },
  {
    path: '/contracts/:id',
    name: 'ContractDetail',
    component: () => import('../views/ContractDetail.vue')
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: InvoiceList
  },
  {
    path: '/invoices/:id',
    name: 'InvoiceDetail',
    component: () => import('../views/InvoiceDetail.vue')
  },
  {
    path: '/mrr',
    name: 'Payments',
    component: () => import('../views/Payments.vue')
  },
  {
    path: '/forecast-mrr',
    name: 'ForecastMRR',
    component: () => import('../views/ForecastMRR.vue')
  },
  {
    path: '/payment-periods',
    name: 'PaymentPeriods',
    component: PaymentPeriodsList
  },
  {
    path: '/payment-periods/:paymentAccountId/:paymentPeriod',
    name: 'PaymentPeriodWithoutContract',
    component: () => import('../views/PaymentPeriodDetail.vue')
  },
  {
    path: '/test-payment-period/:paymentAccountId/:paymentPeriod',
    name: 'TestPaymentPeriod',
    component: () => import('../views/PaymentPeriodDetail.vue')
  },
  {
    path: '/payment-periods/:paymentAccountId/:paymentPeriod/',
    name: 'PaymentPeriodDetail',
    component: () => import('../views/PaymentPeriodDetail.vue')
  },
  {
    path: '/forecasts',
    name: 'Forecasts',
    component: () => import('../views/ForecastList.vue')
  },
  {
    path: '/forecasts/:id',
    name: 'ForecastDetail',
    component: () => import('../views/ForecastDetail.vue')
  },
  {
    path: '/space-limits',
    name: 'SpaceLimits',
    component: () => import('../views/SpaceLimitsList.vue')
  },
  {
    path: '/space-limits-management',
    name: 'SpaceLimitsManagement',
    component: () => import('../views/SpaceLimitsManagement.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const {consumeTokenFromQuery, redirectToIdp} = useIdpAuth()

  consumeTokenFromQuery(true)

  const userStore = useUserStore()

  try {
    await userStore.fetchUser()

    next()
  } catch (err) {
    const status = err.response?.status

    if (status === 401) {
      redirectToIdp('login', window.location.origin + to.fullPath)

      return
    }

    next()
  }
})

export default router
